/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const carouselUpdate = (customisations: any) => {
  let carouselPrevIcon = document.getElementsByClassName('carousel-control-prev');
  let carouselnextIcon = document.getElementsByClassName('carousel-control-next');
  let carouselprevControlIcon = document.getElementsByClassName('carousel-control-prev-icon');
  let carouselnextControlIcon = document.getElementsByClassName('carousel-control-next-icon');
  let carouselContent = document.getElementsByClassName('carousel-content');
  if (carouselContent) {
    Array.from(carouselContent).forEach((carousel) => {
      (carousel as HTMLElement).style.backgroundColor = customisations?.imageBgColor;
    });
  }
  const sizeOfIcon =
    customisations?.iconSize === '10px'
      ? '16px'
      : customisations?.iconSize === '16px'
      ? '24px'
      : '32px';
  const getTopValue = (caption?: string, iconAlignment?: string): string => {
    if (caption === 'top' && iconAlignment === 'Top') return '15%';
    if (caption === 'bottom' && iconAlignment === 'Bottom') return '80%';
    if (caption === 'bottom' && iconAlignment === 'Top') return '5%';
    if (caption === 'bottom' && iconAlignment === 'Default') return '45%';
    if (caption === 'top' && iconAlignment === 'Bottom') return '85%';
    return '45%';
  };
  if (carouselPrevIcon[0] && carouselnextIcon[0]) {
    const doubleSize = parseInt(sizeOfIcon) * 2 + 'px';
    const caption = customisations?.setcaptionAlignment;
    const iconAlignment = customisations?.iconAlignment;
    carouselPrevIcon[0].setAttribute(
      'style',
      `background-color: ${
        customisations?.iconColor
      }; width: ${doubleSize}; height: ${doubleSize}; top: ${getTopValue(caption, iconAlignment)};`,
    );
    carouselnextIcon[0].setAttribute(
      'style',
      `background-color: ${
        customisations?.iconColor
      }; width: ${doubleSize}; height: ${doubleSize}; top: ${getTopValue(caption, iconAlignment)};`,
    );
    carouselprevControlIcon[0].setAttribute(
      'style',
      `width: ${sizeOfIcon}; height: ${sizeOfIcon};`,
    );

    carouselnextControlIcon[0].setAttribute(
      'style',
      `width: ${sizeOfIcon}; height: ${sizeOfIcon};`,
    );

    if (customisations?.iconType === '50%') {
      carouselPrevIcon[0]?.setAttribute(
        'style',
        carouselPrevIcon[0]?.getAttribute('style') + `border-radius: ${customisations?.iconType};`,
      );
      carouselnextIcon[0]?.setAttribute(
        'style',
        carouselnextIcon[0]?.getAttribute('style') + `border-radius: ${customisations?.iconType};`,
      );
    }

    if (customisations?.iconAlignment === 'Top') {
      carouselPrevIcon[0].className = 'carousel-control-prev-top';
      carouselnextIcon[0].className = 'carousel-control-next-top';
    }
    if (customisations?.iconAlignment === 'Bottom') {
      carouselPrevIcon[0].className = 'carousel-control-prev-bottom';
      carouselnextIcon[0].className = 'carousel-control-next-bottom';
    }
  }
};

export const wrapIframeInVideoWrapper = (parameters: any) => {
  // To wrap the iframe inside a div to make the video responsive
  return parameters.map((content: any) => {
    let object = JSON.parse(JSON.stringify(content));
    let origString = object.text;
    let stringToAdd = "<div class='videoWrapper'>";
    let indexPosition = object.text.indexOf('<iframe');
    if (indexPosition !== -1) {
      let newString =
        origString.slice(0, indexPosition) + stringToAdd + origString.slice(indexPosition);
      indexPosition = newString.indexOf('</iframe>');
      newString = newString.slice(0, indexPosition) + '</div>' + newString.slice(indexPosition);
      object.text = newString;
    }
    return object;
  });
};
